module.exports = __webpack_public_path__ + "img/11.f5c2f640.jpg";